'use client';
import React from 'react';
import Slider from 'react-slick';
import MWSVG from './svg';
import Link from 'next/link';

const PythonIndustryWiseCases: React.FC = () => {
    const industrywisecases = {
        dots: true,
        arrow: true,
        autoplay: false,
        speed: 500, // Set slide transition speed
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                },
            },
        ],
    };
    return (
        <>
            <section className="section-py case-study">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid lg:grid-cols-12 mb-10">
                        <div className="lg:col-span-9">
                            <h2 className="mb-2.5">Industry-Wise Python Development Use Cases</h2>
                            <p className="mb-0 fw-600 text-secondary">
                                At Moweb, we craft tailored Python solutions that drive innovation and efficiency across
                                industries. From AI-driven automation to secure web applications, our expertise ensures scalable,
                                high-performance software designed for your business needs.
                            </p>
                        </div>
                    </div>

                    <div className="section pb-16 dark:bg-black case-study-slider-img case-study-slider-aiml python-enabled-slider mb-10">
                        <div className="container-fluid lg:container-fluid mx-auto">
                            <Slider {...industrywisecases} data-aos="fade-up" data-aos-duration="2000" data-aos-delay="500">
                                <div>
                                    <div className="lg:mx-3 md:mx-3 mx-0">
                                        <div className="card h-full python-card">
                                            <div className="card-body">
                                                <div className="card-description">
                                                    <div>
                                                        <div className="industrywise-case-heading python-indus-heading">
                                                            <h3 className="fs-lg text-white">FinTech</h3>
                                                        </div>
                                                        <div className="p-5">
                                                            <p className="fs-mdlg mb-2.5 text-textcolor fw-600">Use Cases</p>
                                                            <div className="gap-2.5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
                                                                <div className="flex items-center mb-0 fw-400 fs-md text-secondary">
                                                                    <MWSVG
                                                                        id="tabler-icon-square-rounded-check-filled"
                                                                        svgClassName="me-2.5 mt-[2px] min-w-[24px]"
                                                                    />
                                                                    Secure payment gateways and transaction processing
                                                                </div>
                                                                <div className="flex items-center mb-0 fw-400 fs-md text-secondary">
                                                                    <MWSVG
                                                                        id="tabler-icon-square-rounded-check-filled"
                                                                        svgClassName="me-2.5 mt-[2px] min-w-[24px]"
                                                                    />
                                                                    AI-powered fraud detection and risk assessment
                                                                </div>
                                                                <div className="flex items-center mb-0 fw-400 fs-md text-secondary">
                                                                    <MWSVG
                                                                        id="tabler-icon-square-rounded-check-filled"
                                                                        svgClassName="me-2.5 mt-[2px] min-w-[24px]"
                                                                    />
                                                                    Blockchain-based financial solutions
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-3 md:mx-3 mx-0">
                                        <div className="card h-full python-card">
                                            <div className="card-body">
                                                <div className="card-description">
                                                    <div>
                                                        <div className="industrywise-case-heading python-indus-heading">
                                                            <h3 className="fs-lg text-white">Healthcare</h3>
                                                        </div>
                                                        <div className="p-5">
                                                            <p className="fs-mdlg mb-2.5 text-textcolor fw-600">Use Cases</p>
                                                            <div className="gap-2.5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
                                                                <div className="flex items-center mb-0 fw-400 fs-md text-secondary">
                                                                    <MWSVG
                                                                        id="tabler-icon-square-rounded-check-filled"
                                                                        svgClassName="me-2.5 mt-[2px] min-w-[24px]"
                                                                    />
                                                                    AI-driven medical diagnostics and predictive analytics
                                                                </div>
                                                                <div className="flex items-center mb-0 fw-400 fs-md text-secondary">
                                                                    <MWSVG
                                                                        id="tabler-icon-square-rounded-check-filled"
                                                                        svgClassName="me-2.5 mt-[2px] min-w-[24px]"
                                                                    />
                                                                    HIPAA-compliant patient data management
                                                                </div>
                                                                <div className="flex items-center mb-0 fw-400 fs-md text-secondary">
                                                                    <MWSVG
                                                                        id="tabler-icon-square-rounded-check-filled"
                                                                        svgClassName="me-2.5 mt-[2px] min-w-[24px]"
                                                                    />
                                                                    Telemedicine and healthcare automation
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-3 md:mx-3 mx-0">
                                        <div className="card h-full python-card">
                                            <div className="card-body">
                                                <div className="card-description">
                                                    <div>
                                                        <div className="industrywise-case-heading python-indus-heading">
                                                            <h3 className="fs-lg text-white">E-Commerce</h3>
                                                        </div>
                                                        <div className="p-5">
                                                            <p className="fs-mdlg mb-2.5 text-textcolor fw-600">Use Cases</p>
                                                            <div className="gap-2.5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
                                                                <div className="flex items-center mb-0 fw-400 fs-md text-secondary">
                                                                    <MWSVG
                                                                        id="tabler-icon-square-rounded-check-filled"
                                                                        svgClassName="me-2.5 mt-[2px] min-w-[24px]"
                                                                    />
                                                                    AI-powered recommendation engines
                                                                </div>
                                                                <div className="flex items-center mb-0 fw-400 fs-md text-secondary">
                                                                    <MWSVG
                                                                        id="tabler-icon-square-rounded-check-filled"
                                                                        svgClassName="me-2.5 mt-[2px] min-w-[24px]"
                                                                    />
                                                                    Inventory and supply chain automation
                                                                </div>
                                                                <div className="flex items-center mb-0 fw-400 fs-md text-secondary">
                                                                    <MWSVG
                                                                        id="tabler-icon-square-rounded-check-filled"
                                                                        svgClassName="me-2.5 mt-[2px] min-w-[24px]"
                                                                    />
                                                                    Secure and scalable e-commerce platforms
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-3 md:mx-3 mx-0">
                                        <div className="card h-full python-card">
                                            <div className="card-body">
                                                <div className="card-description">
                                                    <div>
                                                        <div className="industrywise-case-heading python-indus-heading">
                                                            <h3 className="fs-lg text-white">Education & E-Learning</h3>
                                                        </div>
                                                        <div className="p-5">
                                                            <p className="fs-mdlg mb-2.5 text-textcolor fw-600">Use Cases</p>
                                                            <div className="gap-2.5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
                                                                <div className="flex items-center mb-0 fw-400 fs-md text-secondary">
                                                                    <MWSVG
                                                                        id="tabler-icon-square-rounded-check-filled"
                                                                        svgClassName="me-2.5 mt-[2px] min-w-[24px]"
                                                                    />
                                                                    Interactive e-learning platforms
                                                                </div>
                                                                <div className="flex items-center mb-0 fw-400 fs-md text-secondary">
                                                                    <MWSVG
                                                                        id="tabler-icon-square-rounded-check-filled"
                                                                        svgClassName="me-2.5 mt-[2px] min-w-[24px]"
                                                                    />
                                                                    AI-based virtual tutors and assessments
                                                                </div>
                                                                <div className="flex items-center mb-0 fw-400 fs-md text-secondary">
                                                                    <MWSVG
                                                                        id="tabler-icon-square-rounded-check-filled"
                                                                        svgClassName="me-2.5 mt-[2px] min-w-[24px]"
                                                                    />
                                                                    Learning management system (LMS) development
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div>
                                    <div className="lg:mx-3 md:mx-3 mx-0">
                                        <div className="card h-full python-card">
                                            <div className="card-body">
                                                <div className="card-description">
                                                    <div>
                                                        <div className="industrywise-case-heading python-indus-heading">
                                                            <h3 className="fs-lg text-white">Logistics & Supply Chain</h3>
                                                        </div>
                                                        <div className="p-5">
                                                            <p className="fs-mdlg mb-2.5 text-textcolor fw-600">Use Cases</p>
                                                            <div className="gap-2.5 ps-0 fs-md fw-500 flex flex-col reactjs-checkboxset">
                                                                <div className="flex items-center mb-0 fw-400 fs-md text-secondary">
                                                                    <MWSVG
                                                                        id="tabler-icon-square-rounded-check-filled"
                                                                        svgClassName="me-2.5 mt-[2px] min-w-[24px]"
                                                                    />
                                                                    Smart routing and fleet management
                                                                </div>
                                                                <div className="flex items-center mb-0 fw-400 fs-md text-secondary">
                                                                    <MWSVG
                                                                        id="tabler-icon-square-rounded-check-filled"
                                                                        svgClassName="me-2.5 mt-[2px] min-w-[24px]"
                                                                    />
                                                                    AI-driven demand forecasting
                                                                </div>
                                                                <div className="flex items-center mb-0 fw-400 fs-md text-secondary">
                                                                    <MWSVG
                                                                        id="tabler-icon-square-rounded-check-filled"
                                                                        svgClassName="me-2.5 mt-[2px] min-w-[24px]"
                                                                    />
                                                                    IoT-powered logistics automation
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </Slider>
                        </div>
                    </div>
                    <div className="row grid lg:grid-cols-12">
                        <div className="lg:col-span-9">
                            <div>
                                <Link href="/contact-us" className="btn btn-primary">
                                    {'Discuss Your Project'}
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};
export default PythonIndustryWiseCases;
